const cancel = 'Avbryte'
const save = 'Lagre'

export default {

  global: {
    generalError: 'Å nei! Forespørselen ble dessverre ikke bli behandlet. Vennligst last siden på nytt.',
    signature: 'Vennlig hilsen,',
  },

  component: {
    actionBar: {
      actions: 'Handlinger',
      hideActions: 'Skjul handlinger',
    },

    addButton: {
      add: 'Legg til',
    },

    attachments: {
      add: 'Legg til CV eller andre vedlegg',
      placeholderWithDescription: 'Legg til de forespurte vedleggene',
      remove: 'Fjerne',
      allowedFileTypes: 'Tillatte filtyper',
      errors: {
        size: 'Filen er for stor, maksimal filstørrelse er 5MB.',
        empty: 'Filen har ingen data',
        invalidType: fileType => `Beklager, av sikkerhetsmessige grunner er ikke ${fileType}-filer tillatt`,
        typeNotWhitelisted: 'Beklager, filtypen er ikke tillatt.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Personvernerklæring',
      termsLinkText: 'Vilkår og betingelser',
      privacyPolicyText: 'Vi verdsetter personvernet ditt, les vår ',
      termsText1: 'Les og godta ',
      termsText2: 'før du gir oss personopplysningene dine.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Dersom du ikke ønsker at vi skal behandle dine personlige data, kan du be om å bli fjernet ved å kontakte oss på ${mail}.`,
      customSupportPrivacyInfo: link => `Hvis du ikke vil at vi skal behandle personopplysningene dine, kan du be om fjerning ved å kontakte ${link}.`,
    },

    buttons: {
      close: 'Lukke',
    },

    competencies: {
      addCompetency: 'Legg til ny kompetanse',
      edit: 'Rediger kompetanse',
      done: 'Ferdig',
      defaultsDescription: 'Dersom du er usikker på hvilke kompetanser du skal bruke, har vi definert noen bra standarder du kan begynne med.',
      getDefaults: 'Få standardene',
    },

    competency: {
      warning: 'Fjern kompetanse og alle dens vurderinger?',
    },

    confirmDelete: {
      delete: 'Slette',
      cancel: 'Avbestillings',
      confirm: 'Bekrefte',
    },

    confirm: {
      cancel: 'Fjerne opptak',
      confirm: 'Try again',
    },

    confirmButton: {
      wait: count => `Vent ${count}`,
      confirm: 'Bekrefte',
    },

    controlStatus: {
      text: {
        empty: 'Fyll inn',
        valid: () => 'Klar',
      },
      textarea: {
        empty: 'Fyll inn',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Sett',
        valid: () => 'Klar',
      },
      file: {
        empty: 'Velg',
        valid: () => 'Endre',
      },
      list: {
        empty: 'Legg til',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Søk',
        valid: () => 'Klar',
      },
    },

    cookieConsentModal: {
      title: 'Nettstedet vårt bruker informasjonskapsler',
      body: 'Ved å godta alle informasjonskapsler, godtar du lagring av informasjonskapsler på enheten din for å forbedre nettstedets navigering, analysere bruken av nettstedet og hjelpe til med markedsføringstiltakene våre.',
      learnMoreLinkText: 'Les mer om hvordan vi bruker informasjonskapsler',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Administrer informasjonskapsler',
      acceptAll: 'Godta alle informasjonskapsler',
      manageTitle: 'Administrer samtykkepreferanser',
      necessaryCookiesTitle: 'Nødvendige informasjonskapsler',
      necessaryCookiesBody:
        'Disse informasjonskapslene er nødvendige for at nettstedet skal fungere og kan ikke slås av i våre systemer.',
      performanceCookiesTitle: 'Ytelsesinformasjonskapsler',
      performanceCookiesBody:
        'Disse informasjonskapslene lar oss telle besøk og trafikkkilder, slik at vi kan måle og forbedre ytelsen til nettstedet vårt.',
      confirmChoices: 'Bekreft valgene mine',
      marketingCookiesTitle: 'Informasjonskapsler for markedsføring',
      marketingCookiesBody:
        'Disse informasjonskapslene lar oss tilpasse reklame og måle annonseytelsen.',
      functionalCookiesTitle: 'Funksjonelle informasjonskapsler',
      functionalCookiesBody:
        'Disse informasjonskapslene brukes til å forbedre funksjonaliteten til nettstedet. Uten disse informasjonskapslene kan enkelte funksjoner bli utilgjengelige. Eksempler på funksjonalitetskapsler inkluderer nettchattetjenester og brukerpreferanser.',
    },

    emailAddresses: {
      remove: 'Fjerne',
      importCsv: 'Import CSV',
      invalidEmails: 'Ugyldige e-postadresser ble funnet.',
      maxCsvEntryErrorNotification: amount =>
        `Maks ${amount} csv-oppføringer er tillatt.`,
      importCsvTooltip:
        ' CSV-linjene kan inneholde enten en e-postadresse eller både en e-postadresse og et telefonnummer. Hver rad representerer en mottaker. Telefonnumre må være i internasjonalt format (E.164), f.eks. <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-postmeldingen ble returnert. Bekreft at mottageren mottok meldingen din.',
      },
      Permanent: {
        General: 'E-postleveringen mislyktes. Mottagers e-postleverandør avviste meldingen.',
        NoEmail: 'E-postadressen eksisterer ikke.',
        Suppressed: 'E-posten ble ikke levert grunnet tidligere mislykkede leveringsforsøk.',
      },
      Transient: {
        General: 'E-postmeldingen ble returnert. Bekreft at mottageren mottok meldingen din.',
        MailboxFull: 'Mottagers e-postkasse er full.',
        MessageTooLarge: 'Meldingsinnholdet er for stort.',
        ContentRejected: 'Meldingsinnholdet ble avvist.',
        AttachmentRejected: 'Vedlegget ble avvist.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'Det angitte nummeret er allerede tilknyttet en kandidat i intervjuet.',
    },

    error403: {
      heading: 'Tilgang forbudt',
      content: 'Sørg for at du er logget inn på riktig konto, og at du har blitt invitert til å vurdere denne stillingen i Recright. Sørg også for at du bruker Recright med ett nettleservindu om gangen.',
      link: 'Forside',
    },

    error404: {
      heading: 'Ingenting der',
      content: 'Vi søkte alt vi kunne, men det er ingen nettside på adressen du oppga. Kanskje du har fulgt en utløpt link eller kom til å skrive inn feil adresse.',
      link: 'Forside',
    },

    error410: {
      heading: 'Lukket',
      content: 'Jobben kan ikke vises fordi den enten er stengt eller søknadsperioden er avsluttet.',
      link: 'Forsiden',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    footer: {
      terms: 'Recrights vilkår og betingelser for bruk',
      license: 'Recrights generelle tjenestevilkår',
      privacyPolicy: 'Personvernregler',
      customSupport: link => `Kontakt ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Hvordan vil du vurdere intervjuopplevelsen?',
      howWouldYouRateJobAd: 'Hvordan vurderer du søknadsopplevelsen?',
      yourResponseIsAnonymous: 'Svaret ditt er anonymt.',
      thankYouFeedback: 'Takk for tilbakemeldingen!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Beklager, filtypen er ikke tillatt.',
      isRequired: 'Dette feltet er nødvendig.',
      isEmail: value => `${value} er ikke en gyldig e-post.`,
      isDate: value => `${value} er ikke en gyldig dato.`,
      invalidUrl: 'URL er ugyldig.',
      singleHireEndError: 'Enkeltleie kan ikke brukes i mer enn 60 dager.',
      isNotTooOldForLive: 'Datoen er passert.',
      isNotAfterEndDate: 'Den valgte datoen kan ikke være etter datoen for når stillingsannonsen avsluttes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Telefonnummeret har allerede blitt lagt til.',
      duplicateCompetency: 'En kompetanse med det navnet finnes allerede',
      isNotDuplicateTemplateName: 'E-postmal med det navnet finnes allerede.',
    },

    jobAdApplication: {
      name: 'Navn',
      email: 'E-post',
      phone: 'Telefonnummer',
      city: 'By',
      applyForPosition: 'Søk på stilling',
      back: 'Tilbake',
      continue: 'Fortsette',
      submit: 'Send',
      saveForLater: 'Fortsette senere',
      namePlaceholder: 'Oppgi ditt navn',
      emailPlaceholder: 'Oppgi din e-postadresse',
      phonePlaceholder: 'Oppgi ditt telefonnummer',
      cityPlaceholder: 'Skriv inn ditt nåværende hjemsted',
      links: 'Du kan oppgi linker',
      legendAdditionalFields: 'Tilleggsinformasjon',
      legendBasicInfo: 'Grunnleggende informasjon',
      legendLinks: 'Linker',
      legendAttachments: 'Vedlegg',
      coverLetter: 'Følgebrev',
      attachments: 'Vedlegg',
      introduction: 'Skriv introduksjonen din her',
      thankYou: 'Mange takk.',
      luck: 'Lykke til!',
      close: 'Lukk',
      required: '* Feltene merket med stjerne er obligatoriske.',
    },

    jobAdContainer: {
      endTime: date => (date ? `åpent til ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Søk på jobb',
    },

    jobAdQuickInterview: {
      back: 'Tilbake',
      submit: 'Send',
      saveForLater: 'Fortsette senere',
      title: 'Hurtig videointervju',
      description: 'For å bli raskere kjent med deg ber vi om at du gir et kort svar på vårt hurtige intervjuspørsmål. Vis litt personlighet og gi søknaden din sjel.',
      requiredNote: 'Merk at dette er en del av søknadsprosessen. Rekruttereren mottar ikke søknaden din før du har spilt inn svaret ditt.',
      reminderNote: 'Du kan spille inn svaret med en gang, eller du kan fortsette senere ved å motta en påminnelsen til e-posten din.',
    },

    jobAdRow: {
      responses: 'Søknader',
      status: {
        open: 'Åpen',
        filled: 'Bemannet',
        cancelled: 'Avbrutt',
        done: 'Ferdig',
        close: 'Lukke',
        draft: 'Lukket (utkast)',
        hidden: 'Skjult',
      },
    },

    interviewRow: {
      responses: 'Kandidater',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Vis LinkedIn profil',
    },

    linkedInButton: {
      error: 'Feil ved innhenting av profil. Vennligst prøv på nytt.',
      buttonText: 'Søk med LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Du kan bruke din LinkedIn profil til å forhåndsutfylle søknadsskjemaet',
      linkedInOr: 'Eller',
      error: 'Feil ved innhenting av profil. Vennligst prøv på nytt.',
    },

    linkListInput: {
      addField: 'Legg til',
      removeField: 'Fjerne',
      invalidUrl: 'URL er ugyldig.',
    },

    liveRoom: {
      greeting: name => `Hei, ${name}.`,
      notYetStarted: startTime =>
        `Intervjuet har ikke startet ennå. Intervjuet starter kl. ${startTime}.`,
      interviewTitle: title => `Intervjutittel: ${title}`,
      interviewStartsIn: timeLeft => `Intervjuet starter om: ${timeLeft}`,
      interviewHasEnded: 'Intervjuet er avsluttet.',
    },

    loadingButton: {
      loading: 'Laster inn...',
      saving: 'Lagring...',
      sending: 'Utsending...',
    },

    modalApplicationForm: {
      applyForPosition: 'Søk på stilling',
      continue: 'Fortsette',
      name: 'Oppgi ditt navn',
      email: 'Oppgi din e-postadresse',
      phoneNumber: 'Oppgi ditt telefonnummer',
      links: 'Du kan oppgi linker',
      legendLinks: 'Linker',
      legendAttachments: 'Vedlegg',
      coverLetter: 'Følgebrev',
      attachments: 'Vedlegg',
      introduction: 'Skriv introduksjonen din her',
      thankYou: 'Mange takk.',
      luck: 'Lykke til!',
      close: 'Lukk',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Delbar offentlig link',
      info: 'Her er en offentlig adresse til jobbannonsen som du kan dele.\nAlle som er interresert i stillingen kan se jobbannonasen \nog søke på den.\nDu vil motta den vanlige varslingen ettersom søknadene kommer inn.\n\nHer er en offenlit link til jobbannonsen:',
    },

    modalVideoAdd: {
      title: 'Legg til en ny video',
      chooseTitle: 'Legg til en ny video',
      titlePlaceholder: 'Oppgi video tittel her',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Last opp en ny video',
      info: 'Maksimal tillatt video størrelse er 500 mb. Vi anbefaler at videoene er komprimert før opplasting, på denne måten laste opp og konverteringen vil ta kortere tid.',
    },

    modalCandidateInfo: [
      {
        headline: 'Ta opp svaret ',
        content: 'så mange ganger du vil og til du føler deg fornøyd. Svarene lagres umiddelbart etter opptak, og du kan gå tilbake til intervju når som helst gjennom lenken sendt til din e-post.',
        mobileContent: 'så mange ganger du vil og til du føler deg fornøyd. Legg videoen til intervjuet. Du vil se videoen lastes opp og lagres til intervjuet. Du kan returnere til videointervjuet gjennom linken du fikk på e-post. <br><br><strong>Hvis videoskjermen din forblir svart, og du bruker en Apple-mobilenhet, finner du instruksjoner om hvordan du løser problemet <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">her</a>.</strong>',
      },
      {
        headline: 'Sjekk umiddelbart etter opptak ',
        content: 'at stemmen din kan høres uten problemer, og at videoen spilles som normalt. Når du trykker på "send svar"-knappen, vil videoen bli låst. Det er derfor ikke mulig å endre svaret etter det.',
      },
      {
        headline: 'Når du har tatt opp alle svarene, ',
        content: 'og intervjuet er ferdig, trykk på "Send svar og fullfør intervju" Du kan ikke komme til videointervjuet etter å ha trykket på denne knappen. Men hvis du bestemmer deg for å fortsette senere, trykk på "Fortsette senere".',
      },
      {
        headline: 'Hvis du trenger hjelp til å svare på spørsmålene, ',
        content: mailto => `kan du kontakte oss via "Hjelp"-knappen nederst til høyre på siden. Du kan også kontakte oss gjennom e-post til adressen ${mailto}.`,
        customContent: link => `Kontakt ${link}`,
      },
    ],

    navigationBar: {
      back: 'Tilbake',
      dashboard: 'Hovedvisning',
      frontpage: 'Forside',
    },

    personDetails: {
      stage: 'Nivå',
      namePlaceholder: 'Kandidat',
      contact: 'Kontakt',
      links: 'Lenker',
      attachments: 'Vedlegg',
      referrer: 'Opphav',
      referrerInfo: 'Nettstedet som kandidat kom fra til tjenesten.',
      coverLetter: 'Følgebrev',
      noStage: 'Ikke i noe nivå foreløpig',
      lastSeen: time => `sist sett ${time}.`,
      headerAdditionalInformation: 'Tilleggsinformasjon',
      state: {
        invited: 'Invitert',
        visited: 'Besøkt',
        incomplete: 'Ikke fullført',
        completed: 'Fullført',
      },
      notVisited: 'Har ikke vært på intervju.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Også funnet i ${count} andre stillinger`,
    },

    questionsAndResponses: {
      response: 'Respons',
      noResponse: 'Ingen respons',
      resetQuestionResponse: 'Slett kandidatens svar',
      resetQuestionResponseConfirm: questionTitle =>
        `Er du sikker på at du vil tilbakestille spørsmålet «${questionTitle}» for kandidaten og slette deres svar?`,
      resetQuestionResponseConfirm2:
        'Hvis du gjør dette, kan kandidaten svare på dette spørsmålet på nytt.',
    },

    phoneInput: {
      placeholder: example => `Telefonnummer i formatet ${example}`,
    },

    rating: {
      ownVote: 'Din rating',
      yourVotePlaceholder: 'Du har ikke stemt ennå.',
      yourRating: rating => `Din rating: ${rating}`,
      totalVotes: count => `Totalt ${count} rangeringer`,
      mobileModalHeader: 'Legg til din vurdering',
      noRatings: 'Ingen vurderinger ennå',
      yourRatingReset: 'Tilbakestill din stemme',
      averageRating: 'Gjennomsnittlig rangering',
      reset: 'tilbakestill',
    },

    share: {
      share: 'Dele på',
      copy: 'Kopier link',
    },

    sort: {
      sort: 'Sorter',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Valgt',
      change: 'Endre',
    },

    video: {
      videoNotFound: 'Video blir behandlet eller video er ikke funnet',
      retry: 'Prøv igjen',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Legg til en ny video' : 'Velg fil'),
      videoPlaceholder: 'Spill inn din respons',
      uploadPlaceholderCandidate: 'Last opp en video',
      submit: 'Send respons',
      notAnswered: 'Ikke svart på enda',
      remove: 'Fjerne opptak',
      converting: 'Video blir konvertert. Vennligst vent...',
      uploading: 'Video lastes opp. Vennligst vent...',
      error: {
        invalid: 'Den valgte filen er for stor. Velg en annen fil.',
        upload: 'Vi klarte ikke å laste opp videoen, unnskyldninger . Vær så snill, prøv på nytt.',
        transcode: 'Videofilen valgte var ødelagt eller ugyldig, prøv igjen.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Vis mer',
      showLessButtonText: 'Vis mindre',
      infoText1:
        'Hold fanen aktiv i forgrunnen under opptak. Du bør ikke bruke andre programmer under opptak.',
      infoText2:
        'Videobakgrunner fungerer best i de nyeste nettleserne og med en relativt ny og kraftig enhet.',
      infoText3:
        'Kontroller at andre programmer ikke bruker mikrofonen eller kameraet.',
    },

    videoResponse: {
      videoPlaceholder: 'Spill inn din respons',
      uploadPlaceholder: 'Last opp en video',
      submit: 'Send respons',
      notAnswered: 'Ikke svart på enda',
      startInterview: 'Start intervju',
    },

    webcam: {
      useVideoBgButtonText: 'Bruk videobakgrunn',
      removeVideoBgButtonText: 'Fjern videobakgrunn',
      starting: 'Starter...',
      close: 'Lukk kamera',
      remove: 'Fjerne opptak',
      record: 'Ta opp',
      stop: 'Stopp',
      retake: 'Ta på nytt',
      submit: 'Send respons',
      processing: 'Behandler...',
      converting: 'Video blir konvertert. Vennligst vent...',
      uploading: 'Video lastes opp. Vennligst vent...',
      downloading: 'Video lastes ned. Vennligst vent...',
      uploadInProgress: 'Videooverføringen pågår, ikke lukk nettleseren eller endre siden.',
      uploaded: 'Video overført.',
      error: {
        DevicesNotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotAllowedError: 'You didn\'t give a permission to use the camera or microphone.',
        PermissionDismissedError: 'You dismissed permission dialog. Please give permission to use the camera and microphone.',
        PermissionDeniedError: 'You have denied camera or microphone access.',
        NotReadableError: 'Can\'t read camera or microphone stream. Possible hardware issue.',
        SecurityError: 'Can\'t use camera or microphone because of security error',
        stream: 'En feil oppstod. Vennligst start nettleseren din på nytt.',
        download: 'Videonedlasting feilet. Forsøke igjen?',
        upload: 'Videoopplasting feilet. Forsøke igjen?',
        emptyBlob: 'Nettleser eller datamaskinminne er fullt og kan ikke blagre opptaket. Vennligst oppdater siden, og hvis det ikke hjelper må du starte nettleseren.',
        alternativeRecorder: 'Du kan også laste opp filer ved å klikke på denne.',
        reconnecting: 'Tilkoblingen ble avbrutt. Prøver å koble til på nytt.',
      },
    },

    flash: {
      starting: 'Initialiserer...',
      connection_error_hint: 'Nettverkstilkoblingen kunne ikke etableres.\nForsøk å laste siden på ny.',
      permission_hint: 'Du må tillate denne siden å bruke webkameraet og mikrofonen din.',
      searching_camera_hint: 'Søker etter et webkamera...',
      camera_reserved_hint: 'En annen applikasjon eller nettside har reservert webkameraet ditt.\nVennligst lukk den applikasjonen og last inn denne siden på ny.',
      camera_reserved_hint_chrome_extra: '\n\nKjære Chrome-bruker, du må tillate at Recright bruker webkameraet fra dialogen under adressefanen.',
      no_camera_hint: 'Webkamera ble ikke funnet.',
      no_mic_hint: 'Mikrofonen ble ikke funnet.',
      uploading_text: 'Laster opp ...',
      rtmpt_in_use: 'Dette trinnet ville ikke vært nødvendig dersom ditt nettverk/administrator tillot RTMP. Spør oss hvordan.',
      preview_text: 'Dette webkameraet er i forhåndsvisningsmodus',
      close_text: 'Lukk kamera',
      remove_text: 'Fjerne opptak',
      noflash_errortext_install: link => `Det ser ut som du ikke har Adobe Flash Player. Du trenger en flash-plugin for å spille inn videoer. Få flash her: ${link}`,
      noflash_errortext_enable: link => `Hvis du allerede har installert flash, men du fortsatt ser denne meldingen. Se her: ${link}`,
      noflash_errortext_differentbrowser: 'Alternativt kan du prøve med en nettleser som støtter HTML5-opptak. Vi foreslår Chrome eller Firefox.',
    },

    smsMessages: {
      invitationMessage: title =>
        `Hei! Vi ønsker å invitere deg til et videointervju, ${title}! Du har også fått denne invitasjonen på e-post. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'Dette er en forhåndsvisning av intervjuet. Videoopptak er deaktivert, og skjemaopplysningene lagres ikke.',
    },
  },
}
